












































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { Dashboard, DashLayout, DashItem } from 'vue-responsive-dash';
import TableWidget from '@/components/widgets/TableWidget.vue';
import WidgetComponent from '@/components/Widget.vue';
import MapWidget from '@/components/widgets/MapWidget.vue';
import { Getter, Action } from 'vuex-class';
import EventsWidget from '@/components/widgets/EventsWidget.vue';
import MeasurementWidget from '@/components/widgets/MeasurementWidget.vue';
import { Widget } from '@/types';
import GenericButton from '@/components/GenericButton.vue';

@Component({
  components: {
    GenericButton,
    WidgetComponent,
    Dashboard,
    DashLayout,
    DashItem,
  },
})
export default class HomeDashboard extends Vue {
  private widgetData: any = [];
  private confirmReset: boolean = false;
  private key: number = 0;
  private ready: boolean = false;
  private loadAttrs = {
    boilerplate: false,
  };
  private loaded: boolean = false;
  private skeletonHeight: number = 0;

  private dashboardActions: any = [
    { title: 'Reset dashboard', action: () => { this.confirmReset = true; } },
  ];
  @Action private getWidgetsAsync: any;
  @Action private removeWidgetAsync: any;
  private layouts: any[] = [
    {
      breakpoint: 'xl',
      numberOfCols: 6,
      margin: { x: 12, y: 12 },
      items: [],
      useCssTransforms: true,
    },
    {
      breakpoint: 'lg',
      breakpointWidth: 1200,
      numberOfCols: 6,
      margin: { x: 12, y: 12 },
      items: [],
      useCssTransforms: true,
    },
    {
      breakpoint: 'md',
      breakpointWidth: 996,
      numberOfCols: 6,
      margin: { x: 12, y: 12 },
      items: [],
      useCssTransforms: true,
    },
    {
      breakpoint: 'sm',
      breakpointWidth: 768,
      numberOfCols: 6,
      margin: { x: 12, y: 12 },
      items: [],
      useCssTransforms: true,
    },
    {
      breakpoint: 'xs',
      breakpointWidth: 405,
      numberOfCols: 4,
      margin: { x: 12, y: 12 },
      items: [],
      useCssTransforms: true,
    },
    {
      breakpoint: 'xxs',
      breakpointWidth: 0,
      numberOfCols: 4,
      margin: { x: 12, y: 12 },
      items: [],
      useCssTransforms: true,
    },
  ];

  private async mounted() {
    await this.loadDashboard();
  }

  private async loadDashboard() {
    await this.initDashboard();
    this.ready = true;
  }

  private async initDashboard() {
    const projectHeaders: any = { // Better way to handle static headers?
      organisationName: 'Organisation',
      projectName: 'Project',
      deviceActiveCount: 'Active',
      deviceCount: 'Stock',
      deviceFaultCount: 'Fault',
      deviceInactiveCount: 'Inactive',
      usersCount: 'Users',
      userEmail: 'Owner',
    };
    const eventHeaders: any = {
      eventType: 'Event',
      deviceNetworkId: 'NetworkID',
      projectName: 'Project',
      eventId: 'EventID',
      eventMessage: 'Message',
      eventTime: 'Event Occurred',
      name: 'Organisation',
      eventSeverity: 'Severity',
      actions: 'Actions',
    };
    const deviceHeaders: any = {
      deviceId: 'DeviceID',
      networkId: 'NetworkID',
      deviceType: 'Device Type',
      siteName: 'Site',
      locationName: 'Location',
    };

    const widgetData = await this.getWidgetsAsync();
    if (!widgetData) {
      return;
    }

    widgetData.forEach((widget: any) => {
      widget.type = {};
      const headers: any[] = [];

      switch (widget.source) {
        case 'table':
          widget.type = TableWidget;
          (widget.title === 'project')
            ? headers.push()
            : (widget.title === 'devices')
            ? Object.entries(deviceHeaders).forEach(([k, v]) => headers.push({text: v, value: k}))
            : Object.entries(projectHeaders).forEach(([k, v]) => headers.push({text: v, value: k}));

          widget.payload.headers = headers;
          break;
        case 'map':
          widget.type = MapWidget;
          break;
        case 'events':
          widget.type = EventsWidget;
          Object.entries(eventHeaders).forEach(([k, v]) => headers.push({text: v, value: k}));
          widget.payload.headers = headers;
          break;
        case 'chart':
          widget.type = MeasurementWidget;
          Object.entries(eventHeaders).forEach(([k, v]) => headers.push({text: v, value: k}));
          widget.payload.headers = headers;
          break;
        default:
          widget.type = {};
      }
    });

    for (const layout of this.layouts) {
      widgetData.forEach((widget: any, index: number) => layout.items.push({id: index, x: widget.x, y: widget.y, width: widget.width, height: widget.height}));

      if (layout.breakpoint === 'xl' || layout.breakpoint === 'lg') {
        layout.rowHeight = Math.floor(window.innerHeight / 100 * 29);
      } else if (layout.breakpoint === 'md' || layout.breakpoint === 'sm') {
        layout.rowHeight = Math.floor(window.innerHeight / 100 * 26);
      }
    }

    Vue.set(this, 'widgetData', widgetData);
  }

  private getHeight() {
    for (const layout of this.layouts) {
      if (layout.breakpoint === 'xl' || layout.breakpoint === 'lg') {
        layout.rowHeight = Math.floor(window.innerHeight / 100 * 29);
      } else if (layout.breakpoint === 'md' || layout.breakpoint === 'sm') {
        layout.rowHeight = Math.floor(window.innerHeight / 100 * 26);
      }
    }
  }

  private async refreshDashboard() { // TODO: Actual refresh strategy.
    this.ready = false;
    this.widgetData = [];
    await this.loadDashboard();
  }

  private async removeWidget(widgetId: string) {
    if ((await this.removeWidgetAsync(widgetId))) {
      this.widgetData = this.widgetData.filter((widgetToRemove: Widget) => widgetToRemove.id !== widgetId);
    }
  }
}
